module.exports = __webpack_public_path__ + "static/media/ctcanvas.aad27145.png";